import { Autocomplete, Button, IconButton, InputAdornment, TextField, debounce, useTheme } from "@mui/material"
import { MuiEvent } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useSearchTalentsQuery } from "../Redux/api/talentApi";
import { skipToken } from "@reduxjs/toolkit/query";
import { useAppDispatch } from "../Redux/store";
import { setTalentSearchLoading, setTalentSearchResult } from "../Redux/slices/TalentSearchSlice";
import { Close } from "@mui/icons-material";
import { useKaziNavigate } from "../Hooks/useKaziNavigate";

interface IProps {
    disabled?: boolean
    hasPremium: boolean
}

const TalentSearch = ({ disabled = false, hasPremium }:IProps) => {
    /* ******************** Hooks ******************** */
    const theme = useTheme();
    const dispatch = useAppDispatch(); 
    const [searchValue, setSearchValue] = useState<string | null> (null);
    const {
        data: results,
        isLoading: resultsLoading,
        isFetching: resultsFetching
    } = useSearchTalentsQuery((searchValue && {searchString: searchValue}) || skipToken);
    const { navigateToUpgrade } = useKaziNavigate();
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    const handleUpgrade = () => {
        navigateToUpgrade();
    }
    const handleChange = (event: any) => {
        const value = event.target.value;
        setSearchValue(value);
    };
    const debouncedHandleChange = debounce(handleChange, 500);
    const handleClear = () => {
        setSearchValue(null);
        dispatch(setTalentSearchResult([]))
    }
    /* ******************** Effects ******************** */
    useEffect(()=>{
        if (results) dispatch(setTalentSearchResult(results));
    },[results])
    useEffect(()=>{
        const isLoading = resultsLoading || resultsFetching;
        dispatch(setTalentSearchLoading(isLoading));
    },[resultsLoading, resultsFetching])
    /* ******************** JSX ******************** */
    return (
        <>
            <TextField 
                size="small"
                placeholder="Search for a talent to message…"
                fullWidth  
                disabled={disabled || !hasPremium}
                onChange={debouncedHandleChange}
                InputProps={{
                    endAdornment: 
                    <InputAdornment position="end">
                        {
                           !hasPremium && 
                           <Button variant="outlined" size="small" onClick={handleUpgrade}>Upgrade</Button> 
                        }
                        {/* <IconButton
                            aria-label="clear talent search"
                            onClick={handleClear}
                        >
                            <Close  fontSize="small"/>
                        </IconButton> */}
                    </InputAdornment>
                }}
                sx={{
                    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":{
                        border: "none",
                    },
                    ".MuiInputBase-root":{
                        background: hasPremium ? theme.palette.green[50] : theme.palette.warning.main,
                        color: 'primary.main',
                        borderRadius: "58px",
                        paddingRight: "16px !important"
                    },
                    ".Mui-expanded": {
                        ".MuiInputBase-root":{
                            borderRadius: "28px 28px 0 0",
                            border: "none"
                        },
                        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":{
                            border: "none"
                        },
                    },
                    ".MuiAutocomplete-popper": {
                        ".MuiPaper-root":{
                            borderRadius: "0 0 28px 28px"
                        },
                    }
                }}
            />
        </>
    )
}

export default TalentSearch
